(function ($) {

	$(function () {
		'use strict';

    //initialize swiper when document ready
    /*const mySwiper = new Swiper ('[data-js="slider-program-icons"]', {
      // Optional parameters
      a11y: {
        enabled: true,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        400: {
          slidesPerView: 2,
        },
        600: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        850: {
          slidesPerView: 6,
        },
      }
    });*/

  });
})(jQuery);
